import React from "react";

export default function Mail() {
  return (
    <svg
      width="1.75rem"
      height="1.75rem"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>mail</title>

      <g id="Complete">
        <g id="mail">
          <g>
            <polyline
              fill="none"
              points="4 8.2 12 14.1 20 8.2"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.3"
            />

            <rect
              fill="none"
              height="14"
              rx="2"
              ry="2"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.3"
              width="18"
              x="3"
              y="6.5"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
